import i18n from '@src/plugins/i18n'
import number from './number'
import numeral from 'numeral'

function shortName(str = '') {
  if (!str) return ''
  str = str.match(/\b(\w)/g).join('')
  return str.substring(0, 1).toUpperCase()
}
function trans(str) {
  return i18n.t(str)
}
function transFormat(o) {
  if (typeof o == 'object') return o[i18n.locale] || o[i18n.fallbackLocale]
  return i18n.t(o)
}
function convertArrayToString(items, field = 'name') {
  return items.map((x) => x[field]).join()
}
function dateTime(value, type) {
  if (!value) {
    return
  }
  let temp = new Date(value)
  if (!isValidDate(temp) && typeof value == 'string') {
    temp = new Date(parseFloat(value))
  }
  return i18n.d(temp, type || 'long')
}
function dateFormat(value, from, to) {
  if (!value) {
    return
  }
  if (!from) return value
  const moment = require('moment')
  let temp = moment(value, from)
  if (to) {
    temp = temp.format(to)
  }
  return temp
}
function date(value, type = 'short', format = '') {
  if (!value) {
    return
  }
  if (format) {
    const moment = require('moment')
    let temp = moment(value, format).toDate()
    return i18n.d(temp, type)
  } else {
    let temp = new Date(value)
    if (!isValidDate(temp) && typeof value == 'string') {
      temp = new Date(parseFloat(value))
    }
    return i18n.d(temp, type)
  }
}
function time(value, type) {
  if (!value) {
    return
  }
  let temp = new Date(value)
  if (!isValidDate(temp) && typeof value == 'string') {
    temp = new Date(parseFloat(value))
  }
  return i18n.d(temp, type || 'time')
}
function isValidDate(d) {
  return d instanceof Date
}
function userName(user) {
  if (!user.last_name && !user.name) return user.username
  return `${user.last_name || ''} ${user.name || ''}`
}
function getUser(user) {
  if (!user) return 'System'
  return user.name
}
function humanFileSize(bytes, si) {
  const temp = numeral(bytes)
  return temp.format('0.00b')
}
function unitFormat(value, unit = 'meter', default_value) {
  if (!default_value && !value) return ''
  if (unit == 'meter')
    try {
      return `${number(value / 1000, 2, 1)} km`
    } catch (error) {
      return `0.00 km`
    }
  else {
    try {
      return `${number(getMiles(value), 2, 1)} dặm`
    } catch (error) {
      return `0.00 dặm`
    }
  }
}
function getMiles(i) {
  return i * 0.000621371192
}
function timeFormat(s) {
  if (!s) return ''
  let ms = s % 1000
  s = (s - ms) / 1000
  let secs = (s % 60) + ''
  s = (s - secs) / 60
  let mins = (s % 60) + ''
  let hrs = (s - mins) / 60 + ''

  return (
    hrs.padStart(2, 0) + ':' + mins.padStart(2, 0) + ':' + secs.padStart(2, 0)
  )
}
function niceTimeFormat(s) {
  if (!s) return ''
  let ms = s % 1000
  s = (s - ms) / 1000
  let secs = (s % 60) + ''
  s = (s - secs) / 60
  let mins = (s % 60) + ''
  let hrs = (s - mins) / 60 + ''
  if (hrs > 0) {
    return `${hrs} giờ`
  }
  if (mins > 0) {
    return `${mins} p`
  } else {
    return `1 p`
  }
}
function regionFormat(region) {
  if (!region) return ''

  let textShow = region.name
  if (
    region.type &&
    !(region.name || '').toLowerCase().includes(region.type.toLowerCase())
  ) {
    textShow = `${region.type} ${region.name}`
  }
  return textShow
}

let filter = {
  regionFormat,
  shortName,
  timeFormat,
  convertArrayToString,
  date,
  dateTime,
  trans,
  getUser,
  userName,
  time,
  humanFileSize,
  transFormat,
  unitFormat,
  numberFormat: number,
  dateFormat,
  niceTimeFormat,
}
export default filter
